import * as React from 'react';
import { IError, IErrorMessage, IComponentDictionary, ComponentHelper, PropertyHelper, DOMHelper } from '../../helpers';
import { MessageBar, MessageBarType, Layer } from 'office-ui-fabric-react';

interface IProps {
    error: IError;
	components: IComponentDictionary;
	closeError: () => void;
}

export class ErrorDisplay extends React.Component<IProps, any> {

	getControlErrorMessageMarkup = (errorMessage: IErrorMessage, i: number):JSX.Element => {

		let component = this.props.components[errorMessage.componentId];

		if(!component || !component.ControlBlock || !component.ControlBlock.Controls) {
			return null; //component has been deleted
		}

		let control = component.ControlBlock.Controls.filter(c => c.ControlId === errorMessage.controlId)[0];
		if(!control) {
			return null; //control has been deleted
		}

		let componentLabel: string = ComponentHelper.getLabel(component) || '';
		let controlLabel: string = PropertyHelper.getPropertyValue(control.Properties, 'Label');
		let message: string = component.ComponentType.Name +
			(componentLabel ?  (' > ' + componentLabel) : '') + 
			(controlLabel ?  (' > ' + controlLabel) : '') +
			': ' + errorMessage.message; 

		return <li key={i} className='error-message-item control-error'>{this.getMessageLink(message, component.Id)}</li>;
	}

	getPropertyErrorMessageMarkup = (errorMessage: IErrorMessage, i: number):JSX.Element => {
		
		let componentLabel:string = '';
		let componentTypeName:string = '';
		let controlLabel:string = '';

		let component = this.props.components[errorMessage.componentId];
		if(component) {
			componentLabel = ComponentHelper.getLabel(component) || '';
			componentTypeName = component.ComponentType.Name;
		}
		else {
			return null; //component has been deleted
		}
		
		if(errorMessage.controlId && errorMessage.controlId !== '00000000-0000-0000-0000-000000000000') {
			//error related to a control property
			
			let control = component.ControlBlock.Controls.filter(c => c.ControlId === errorMessage.controlId)[0];
			if(control) {
				controlLabel = PropertyHelper.getPropertyValue(control.Properties, 'Label');
			}
			else {
				return null; //control has been deleted
			}

		}

		let message: string = 
			component.ComponentType.Name +
			(componentLabel ?  (' > ' + componentLabel) : '') +
			(controlLabel ? (' >  ' + controlLabel): '') +
			': ' + errorMessage.message;

		
		return <li key={i} className='error-message-item property-error'>{this.getMessageLink(message, component.Id)}</li>;
	}

	getComponentErrorMessageMarkup = (errorMessage: IErrorMessage, i: number):JSX.Element => {

		let component = this.props.components[errorMessage.componentId];

		if(!component) {
			return null;
		}

		let componentLabel: string = ComponentHelper.getLabel(component) || '';
		let message: string = component.ComponentType.Name +
			(componentLabel ?  (' > ' + componentLabel) : '') + 
			': ' + errorMessage.message;

		return <li key={i} className='error-message-item component-error'>{this.getMessageLink(message, component.Id)}</li>;
	}

	getGenericErrorMessageMarkup = (errorMessage: IErrorMessage, i: number):JSX.Element => {
		return <li key={i} className='error-message-item generic-error'>{errorMessage.message}</li>;
	}

	getMessageLink = (message: string, componentId: string):JSX.Element => {
		return (
			<span className='error-message-link-wrapper' onClick={ () => { DOMHelper.scrollToComponent(componentId); return false; } }>{message}</span>
		);
	};

	getErrorMessageMarkup = (errorMessage: IErrorMessage, i: number):JSX.Element => {

		if(errorMessage.propertyId && errorMessage.propertyId !== '00000000-0000-0000-0000-000000000000') {
			return this.getPropertyErrorMessageMarkup(errorMessage, i);
		}
		else if(errorMessage.controlId && errorMessage.controlId !== '00000000-0000-0000-0000-000000000000') {
			return this.getControlErrorMessageMarkup(errorMessage, i);
		}
		else if(errorMessage.componentId && errorMessage.componentId !== '00000000-0000-0000-0000-000000000000') {
			return this.getComponentErrorMessageMarkup(errorMessage, i);
		}
		else {
			return this.getGenericErrorMessageMarkup(errorMessage, i);
		}
		
	}

	render() {

		let { error, closeError } = this.props;

		let errorMessageItems:JSX.Element[] = 
			error.errorMessages ? 
				//map then filter out null error messages (can be caused if message refers to a component, control, or property that no longer exists)
				error.errorMessages.map(this.getErrorMessageMarkup).filter(e => e) : 
				[];

		let exceptionText: string = '';
		if(error.exception) {
			try {
				exceptionText = JSON.stringify(error.exception);
			}
			catch (e) {

			}
		}

		return (
			<Layer>
				<div className='error-display'>
					<MessageBar messageBarType={ MessageBarType.error }	onDismiss={ closeError } >
						An error has occurred
						<ul className='error-list'>
							{ error.operation && error.operation.length ? <li className='error-operation'>Operation: { error.operation }</li> : null }
							<li className='error-code'>Code: { error.code }</li>
							<li className='error-message'>Message: { error.message }</li>
							{ 
								errorMessageItems && errorMessageItems.length ? 
									<li className='error-message-details'>
										Details:<ul>
											{errorMessageItems}
										</ul>
									</li>
								: null
							}
							{
								exceptionText.length ? <li>{'Exception: '+ exceptionText}</li> : null
							}
						</ul>
					</MessageBar>
				</div>
			</Layer>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/error/error-display.tsx